import { Form, InputNumber, Modal, Radio, Select } from '@maxtropy/components';
import { useEffect } from 'react';
import { DeviceRow } from './types';

interface Option {
  label: string;
  value: number | string;
}

interface EditDeviceModalProps {
  open: boolean;
  record?: DeviceRow;
  mainTransformerOptions: Option[];
  deviceTypeOptions: Option[];
  specOptions: Option[];
  onCancel: () => void;
  onSave: (values: Partial<DeviceRow>) => void | Promise<void>;
}

const EditDeviceModal: React.FC<EditDeviceModalProps> = ({
  open,
  record,
  mainTransformerOptions,
  deviceTypeOptions,
  specOptions,
  onCancel,
  onSave,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open || !record) return;
    form.setFieldsValue({
      mainTransformerBelong: record.mainTransformerBelong,
      typeValue: record.typeValue,
      specValue: record.specValue,
      runDurationWeight: record.runDurationWeight,
      isMaintenance: record.isMaintenance ?? false,
    });
  }, [form, open, record]);

  const handleOk = async () => {
    const values = await form.validateFields();
    await onSave(values);
    form.resetFields();
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="配置"
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="保存"
      cancelText="取消"
      size="normal"
      contentClassName="modal-form-content"
    >
      <Form form={form}>
        <Form.Item
          label="主变归属"
          name="mainTransformerBelong"
          rules={[{ required: true, message: '请选择主变归属' }]}
        >
          <Select options={mainTransformerOptions} placeholder="请选择" />
        </Form.Item>
        <Form.Item label="类型" name="typeValue" rules={[{ required: true, message: '请选择类型' }]}>
          <Select options={deviceTypeOptions} placeholder="请选择" />
        </Form.Item>
        <Form.Item label="规格" name="specValue" rules={[{ required: true, message: '请选择规格' }]}>
          <Select options={specOptions} placeholder="请选择" />
        </Form.Item>
        <Form.Item
          label="运行时长权重"
          name="runDurationWeight"
          rules={[{ required: true, message: '请输入运行时长权重' }]}
        >
          <InputNumber min={0} max={99999} precision={0} style={{ width: '100%' }} placeholder="请输入" />
        </Form.Item>
        <Form.Item
          label="是否维护"
          name="isMaintenance"
          rules={[{ required: true, message: '请选择是否维护' }]}
          initialValue={false}
        >
          <Radio.Group>
            <Radio value={true}>是</Radio>
            <Radio value={false}>否</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditDeviceModal;
